/* 🤖 this file was generated by svg-to-ts */
export const sbIconsTachometer: {
  name: 'tachometer';
  data: string;
} = {
  name: 'tachometer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 1.798a8 8 0 0 0-6.928 12 .803.803 0 1 0 1.392-.8 6.336 6.336 0 0 1-.864-3.2 6.4 6.4 0 1 1 11.944 3.2.8.8 0 1 0 1.384.8A8 8 0 0 0 8 1.799Zm2.272 4.608-1.24 1.232A2.328 2.328 0 0 0 8 7.398a2.4 2.4 0 1 0 2.4 2.4c0-.355-.083-.705-.24-1.023l1.24-1.233a.8.8 0 1 0-1.128-1.136M8 10.6A.8.8 0 1 1 8 9a.8.8 0 0 1 .56.224.8.8 0 0 1 .24.576.8.8 0 0 1-.8.8"/></svg>`
};
